import { Container } from "@mui/material";
import React from "react";
import { useParams } from "react-router-dom";
import NoPlatform from "./components/NoPlatform";
import Swyftx from "./platforms/Swyftx";
import SelfWealth from "./platforms/SelfWealth";
import Commbank from "./platforms/Commbank";

export default function LinkPlatform() {
    const params = useParams();
    const platform = params.platform.toLowerCase();

    return (
        <>
            <Container maxWidth="xl" sx={{ mt: 10 }}>
                {platform === "swyftx" && <Swyftx />}
                {platform === "commbank" && <Commbank />}
                {platform === "selfwealth" && <SelfWealth />}
                {!["swyftx", "commbank", "selfwealth"].includes(platform) && (
                    <NoPlatform platform={platform} />
                )}
            </Container>
        </>
    );
}
